import React from "react";
import chatBubbleIcon from "@src/assets/svg/chat-bubble-oval-left-ellipsis.svg";
import { HelpPopoverButtonLink } from "@components/atoms/help-popover-button-link/help-popover-button-link";
import { useI18N } from "@src/language/language-context";

interface ContactButtonTypes {
  url: string;
}

export const ContactButton = ({ url }: ContactButtonTypes) => {
  const i18n = useI18N();
  return (
    <HelpPopoverButtonLink
      icon={chatBubbleIcon}
      link={url}
      text={i18n("modules.helpButton.chatButtonText")}
      altText={i18n("modules.helpButton.chatButtonAltText")}
      targetBlank={false}
    />
  );
};
